import * as React from 'react';

enum ProgressType {
  Determinate = 'determinate',
  Undeterminate = 'undeterminate'
}

interface Props {
  level: number | undefined;
}

export const ProgressBar: React.FunctionComponent<Props> = props => {
  const { level } = props;
  const type =
    level === undefined ? ProgressType.Undeterminate : ProgressType.Determinate;
  const width =
    type === ProgressType.Undeterminate
      ? '100%'
      : (props.level || 0) * 100 + '%';
  return (
    <div className={`progress-bar progress-bar-${type}`}>
      <div className="progress-bar-fill" style={{ width }} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ProgressBar.tsx